const incentiveTestIDs = {
  itBanner: 'incentive-trip-banner',
  itHeaderContainer: 'incentive-trip-header-container',
  itTitle: 'incentive-trip-title',
  itLearnMore: 'it-learn-more',
  itSideTitle: 'it-side-title',
  itDescription: 'it-description',
  itDivider: 'incentive-trip-divider',
  itHeadingContainer: 'incentive-trip-heading-container',
  itSubHeadingContainer: 'incentive-trip-sub-heading-container',
  itDaysLeft: 'it-days-left',
  itQualifyAsRankView: 'it-qualify-as-rank-view',
  itQualifyAsRank: 'it-qualify-as-rank-goal-view',
  itQualifyAsRankGoalCheckbox: 'it-qualify-as-rank-goal-checkbox',
  // used with multiple elements (boxes)

  itQualifyAsRankLablel: 'it-qualify-as-rank-label',
  itNewClientsWithPQVLablel: 'it-new-clients-with-at-least-pqv-label',
  itAdditionalPQVLabel: 'it-additional-pqv-label',
  // used with multiple elements (boxes)
  itNewClientsWithPQVCheckbox: 'it-new-clients-with-at-least-pqv-checkbox',
  itNewClientsWithPQVGoalCheckbox:
    'it-new-clients-with-at-least-pqv-goal-checkbox',
  itNewCoachWithQualifyingClientLabel:
    'it-new-coach-with-qualifying-client-label',
  itNewCoachWithQualifyingClientGoalCheckbox:
    'it-new-coach-with-qualifying-client-goal-checkbox',
  itRequirementsLabel: 'it-requirements-label',
  itGenerateAggregateFQVLabel: 'it-generate-fqv-label-first',
  itGenerateAggregateFQVLabelNumber: 'it-generate-fqv-label-number',
  itGenerateAggregateFQVLabelLast: 'it-generate-fqv-label-last',
  itGenerateAggregateFQVProgressBar: 'it-generate-fqv-progressbar',
  itGenerateAggregateFQVProgressBarValue: 'it-generate-fqv-progressbar-value',
  itGenerateAggregateFQVProgressBarTargetValue:
    'it-generate-fqv-progressbar-target-value',
  itGenerateAggregateFQVIcon: 'it-generate-fqv-icon-',
  itPathLabel: 'it-path-label',
  itSupportPathDescription: 'it-support-path-description',
  itSupportPathGoal: 'it-support-path-icon-',
  itSupportPath: 'it-support-path',
  itQualifiedForIncentiveTripCheckbox: 'it-fully-qualified-for-it-checked',
};

export default incentiveTestIDs;
